import client from './index'

import {
  ApiPaginationResponse,
  ApiResponse,
  PaginationParams,
} from '@/models/api'
import { EvTrip, EvTripExtended } from '@/models/evTrip'
import { User } from '@/models/user'
// import { EvTripCancellationRequest } from '@/models/evTripCancellationRequest'
// import { EvTripDamageReport } from '@/models/evTripDamageReport'
// import { EvTripLog } from '@/models/evTripLog'

import { DamageReport } from './car-ev-data'

import { GetEvTripsParams } from '@/store/evTrips'

export const getEvTrips = (params: PaginationParams & GetEvTripsParams) => {
  return client.get<ApiPaginationResponse<EvTrip>>('/ev-trips', {
    params,
  })
}

// export const getEvTripDetails = (id: string) => {
//   return client.get<ApiResponse<EvTrip>>(`/ev-trips/${id}`)
// }

export const getEvTripDetails = async (id: string) => {
  const response = await client.get<ApiResponse<EvTrip>>(`/ev-trips/${id}`)

  return response
}

export const updateEvTripData = (id: string, data: Partial<EvTrip>) => {
  return client.put<ApiResponse<EvTrip>>(`/ev-trips/${id}`, data)
}

// Admin actions: cancel and end EV trip
export const cancelEvTrip = (id: string) => {
  return client.put<ApiResponse<EvTrip>>(`/ev-trips/${id}/cancel`)
}

export const endEvTrip = (id: string) => {
  return client.put<ApiResponse<EvTrip>>(`/ev-trips/${id}/end`)
}

export const resendEvTripWaybill = (evTripId: string) => {
  return client.post(`/ev-trips/${evTripId}/send-waybill`)
}

export const getEvTripWaybill = (evTripId: string) => {
  return client.get(`/ev-trips/${evTripId}/waybill`)
}

export const getUserEvTrips = async (
  userId: string,
  params: {
    page?: number
    perPage?: number
    sortBy?: string
    sortDirection?: 'asc' | 'desc'
  } = {}
) => {
  const safeParams = {
    page: Number(params.page) || 1,
    perPage: Number(params.perPage) || 10,
    sortBy: String(params.sortBy || 'created_at'),
    sortDirection: params.sortDirection === 'asc' ? 'asc' : 'desc',
  }

  return client.get<ApiResponse<EvTripExtended[]>>(`/ev-trips/user/${userId}`, {
    params: safeParams,
  })
}

export const getReservationsByUser = async (
  userId: string,
  params: Record<string, any> = {}
) => {
  const safeParams = {
    page: Number(params.page) || 1,
    perPage: Number(params.perPage) || 10,
    sortBy: String(params.sortBy || 'created_at'),
    sortDirection: params.sortDirection === 'asc' ? 'asc' : 'desc',
  }

  return client.get<ApiResponse<any[]>>(`/users/ev/reservations/${userId}`, {
    params: safeParams,
  })
}

export const getReservationsByEVCar = async (
  ev_car_profile_id: string,
  params: Record<string, any> = {}
) => {
  const safeParams = {
    page: Number(params.page) || 1,
    perPage: Number(params.perPage) || 10,
    sortBy: String(params.sortBy || 'created_at'),
    sortDirection: params.sortDirection === 'asc' ? 'asc' : 'desc',
  }

  return client.get<ApiResponse<any[]>>(
    `/ev-cars/reservations/${ev_car_profile_id}`,
    {
      params: safeParams,
    }
  )
}

// Finance API methods
export const getFinanceInfo = async (tripId: string) => {
  return client.get<ApiResponse<any>>(`/ev-trips/${tripId}/finance-info`)
}

export const getCreditCardOperations = async (tripId: string) => {
  return client.get<ApiResponse<any>>(
    `/ev-trips/${tripId}/credit-card-operations`
  )
}

export const applyDiscount = async (
  tripId: string,
  discountAmount: number,
  reason?: string
) => {
  return client.post<ApiResponse<any>>(`/ev-trips/${tripId}/apply-discount`, {
    discount_amount: discountAmount,
    reason,
  })
}

export const removeDiscount = async (tripId: string, discountId: string) => {
  return client.delete<ApiResponse<any>>(
    `/ev-trips/${tripId}/remove-discount`,
    {
      data: { discount_id: discountId },
    }
  )
}

export const getDiscounts = async (tripId: string) => {
  return client.get<ApiResponse<any[]>>(`/ev-trips/${tripId}/discounts`)
}

export const processPayment = async (
  tripId: string,
  paymentData: {
    transaction_type: string
    action: string
    amount: number
    amount_src: number
  }
) => {
  return client.post<ApiResponse<any>>(
    `/ev-trips/${tripId}/finish-payment`,
    paymentData
  )
}

export const getTransactions = async (tripId: string, type?: string) => {
  const params = type ? { type } : {}
  return client.get<ApiResponse<any[]>>(`/ev-trips/${tripId}/transactions`, {
    params,
  })
}

// Get EV transactions for a specific car
export const getCarEvTransactions = async (evCarProfileId: string) => {
  return client.get<ApiResponse<any[]>>(
    `/ev-trips/car/${evCarProfileId}/transactions`
  )
}

//damage report
export const getEvCarDamageReports = async (ev_trip_id: string) => {
  return client.get<ApiResponse<DamageReport[]>>(
    '/ev-trips/ev-trip-damage-reports',
    { params: { ev_trip_id: ev_trip_id } }
  )
}

export const markDamageReportResolved = async (reportId: string) => {
  return client.post<ApiResponse<DamageReport>>(
    `/ev-trips/ev-trip-damage-reports/${reportId}`
  )
}

export interface ReceiptItem {
  label: string
  amount: number
  isTotal?: boolean
}

export const getTripReceipt = async (tripId: string) => {
  return client.get<ApiResponse<ReceiptItem[]>>(`/ev-trips/${tripId}/receipt`)
}

export const getTripLogs = async (ev_trip_id: string) => {
  return client.get<ApiResponse<any[]>>(`/ev-trip-logs/${ev_trip_id}`)
}

export const createTripLog = async (ev_trip_id: string, comment: string) => {
  return client.post<ApiResponse<any>>(
    `/ev-trip-logs/${ev_trip_id}/logs/comment`,
    {
      comment: comment,
    }
  )
}
